import { FormattedMessage, useIntl } from 'react-intl';

export const OnboardingProgress = () => {
    return (
        <div className='alert alert-info padding-x-25 padding-y-20 shadow-default'>
            <div className='display-flex justify-content-between gap-5'>
                <div className='display-flex align-items-center'>
                    <div className='margin-right-3 text-color-darker text-medium text-size-18'>
                        <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.welcome.progressbar.title'} />
                    </div>
                </div>
            </div>
            <div className='position-relative padding-y-5'>
                <OnboardingProgressBar />
            </div>
        </div>
    );
};

const OnboardingProgressBar = () => {
    const intl = useIntl();
    return (
        <div className={'margin-y-10'}>
            <div className={'progress'}>
                <OnboardingProgressBarSegment color='success' width={33.0} />
                <OnboardingProgressBarSegment color='success' width={33.0} />
                <OnboardingProgressBarSegment color='info' width={15} animated striped />
            </div>
            <OnboardingProgressBarIcon color='success' icon='rioglyph-shopping-cart' offset={0} />
            <OnboardingProgressBarIcon color='success' icon='rioglyph-user' offset={33.0} />
            <OnboardingProgressBarIcon color='success' icon='rioglyph-truck ' offset={66.0} />
            <OnboardingProgressBarIcon
                color='info'
                icon='rioglyph-wrench'
                offset={82.0}
                tooltip={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.welcome.progressbar.tooltip',
                    defaultMessage:
                        'Order Communication is currently being set up. This process may take up to 2 business days.',
                })}
            />
        </div>
    );
};

type OnboardingProgressBarProps = {
    color: string;
    width: number;
    animated?: boolean;
    striped?: boolean;
};

const OnboardingProgressBarSegment = ({
    color,
    width,
    animated = false,
    striped = false,
}: OnboardingProgressBarProps) => {
    return (
        <div
            className={`progress-bar progress-divider ${striped ? 'progress-bar-striped' : ''} ${animated ? 'progress-bar-animated' : ''} bg-${color}`}
            style={{ width: `${width}%` }}
        />
    );
};

type OnboardingProgressBarIconProps = {
    icon: string;
    color: string;
    offset: number;
    tooltip?: string;
};

const OnboardingProgressBarIcon = ({ icon, color, offset, tooltip = '' }: OnboardingProgressBarIconProps) => {
    const getMarginLeft = (offset: number): string => {
        if (offset === 0) {
            return '0px';
        }
        if (offset === 100) {
            return '-30px';
        }
        return '-15px';
    };

    return (
        <span
            className={`bg-${color} rounded-circle border border-color-white border-width-2 shadow-accent width-30 height-30 position-absolute top-50pct translate-y-50pct display-grid place-items-center`}
            style={{
                left: `${offset}%`,
                marginLeft: getMarginLeft(offset),
            }}
        >
            {tooltip && (
                <div className='bg-info rounded text-color-white padding-x-10 text-size-12 position-absolute left-50pct translate-x-50pct top-25 margin-top-5 text-center width-200 padding-y-10 border border-color-white shadow-default'>
                    {tooltip}
                </div>
            )}
            <span className={`rioglyph ${icon} text-size-16`} />
        </span>
    );
};
